<ng-template #noStatus>
    <mat-chip class="no-status"
              [class.chip-loading]="loadingInitialData"
              [highlighted]="true"
              (click)="statusSelected.emit(statusId)"
              animated
              disableRipple>
        <span>{{ loadingInitialData ? '' : 'No Status' }}</span>
    </mat-chip>
</ng-template>

<mat-chip-set [attr.aria-label]="'status'">
    <mat-chip *ngIf="chip; else noStatus"
              [ngStyle]="{ 'background-color': chip.bgColor, 'color': chip.color }"
              [class.is-default]="isDefaultChip"
              [highlighted]="true"
              (click)="statusSelected.emit(statusId)"
              animated
              disableRipple>
        <span>{{ chip.title }}</span>
    </mat-chip>
</mat-chip-set>
